<template>
  <div class="container">
    <!--banner-->
    <!-- <div class="mbx pc" style="background-color: #fff;">
      <div class="commen">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">关于</a></p>
      </div>
    </div> -->
    <!--付款完成/取消订单/未完成-页面-->
    <div class="fk">
      <div class="commen">
        <!--未完成-->
        <div class="fka ddxq">
          <div class="ddxqb ddxqb_wwc">
            <p>当前状态</p>
            <h6>
              您的订单SDF123456789<span>未完成支付</span>，请在<strong
                id="minute_show"
                >{{ minutes }}</strong
              >:<strong id="second_show">{{ seconds }}</strong
              >内完成付款
            </h6>
            <div class="ddxqb_a fl">
              <a href="javascript:void(0);" @click="paycomplete(1)">前往支付</a>
            </div>
            <span>如不想购买，可以</span>
            <div class="ddxqb_b fl">
              <a href="javascript:void(0);" @click="paycomplete(2)">取消订单</a>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="fkaa">
            <h6>订单信息</h6>
            <div class="fkaa_t fl"><img src="@/view/images/y36.jpg" /></div>
            <div class="fkaa_w fl">
              <h5>印前色彩管理培训</h5>
              <span>在线课程</span>
              <p>¥100.00</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="ddxqa">
            <p>订单编号<span>SDF123456789</span></p>
            <p>支付金额<span>¥ 100元</span></p>
          </div>
        </div>
        <div class="fhlb">
          <a href="javascript:void(0);" @click="back">返回课程列表</a>
        </div>
      </div>
      <div class="fa1f pxnx">
        <div class="commen">
          <div class="bt">
            <h6>相关课程推荐</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="fa1fa pc paynoshow">
            <el-carousel
              class="cardShowban"
              height="450px"
              :loop="true"
              indicator-position="outside"
              :interval="3000"
              arrow="never"
            >
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="fa1fa mob">
            <div class="swiper-container" id="swiper_fa3">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg" />
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>
                          课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介课程简介......
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--支付弹出框-->
    <div class="tank" style="display: none;">
      <div class="tanka">
        <img class="close_a" src="@/view/images/y73.png" />
        <p>请打开微信扫一扫支付</p>
        <h6><img src="@/view/images/y72.png" />100.00元</h6>
        <div class="tanka_a">
          <img src="@/view/images/ewm2.png" />
        </div>
        <img class="tb" src="@/view/images/y64.jpg" />
      </div>
    </div>
    <!--付款成功弹框-->
    <div class="fkcg" style="display: none;">
      <div class="fkcga">
        <img class="close_b" src="@/view/images/y73.png" />
        <img class="ta" src="@/view/images/y74.png" />
        <h6>购买成功</h6>
        <p>订单编号：SDF123456789<br />微信支付：100.00元</p>
        <div class="fkcga_a"><a href="ddxq.html">查看订单</a></div>
      </div>
    </div>
    <!--留言-->
    <!-- <div class="lyan" style="margin-top: 0;">
      <div class="commen">
        <h6>给印工社留言，免费获取更多服务</h6>
        <div class="lyana">
          <input class="input1 fl" v-model="gongsi" type="text" onfocus="if(value=='您的公司') {value=''}"
                 onblur="if (value=='') {value='您的公司'}">
          <input class="input1 fl" v-model="mobile" type="text" onfocus="if(value=='您的联系方式') {value=''}"
                 onblur="if (value=='') {value='您的联系方式'}">
          <textarea class="fl" v-model="content" onfocus="if(value=='您的需求'){value=''}"
                    onblur="if (value ==''){value='您的需求'}"></textarea>
          <input class="input2 fl" type="submit" value="提交留言">
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
    <coun-sel></coun-sel>
  </div>
</template>

<script>
import $ from 'jquery'; // 在需要使用的页面中
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import CounSel from '@/components/counsel';

export default {
  name: 'payNoComplete',
  components: {
    CounSel,
  },
  data() {
    return {
      content: '您的需求',
      mobile: '您的联系方式',
      gongsi: '您的公司',
      minutes: 30,
      seconds: 0,
    };
  },
  methods: {
    init() {},
    num(n) {
      return n < 10 ? `0${n}` : `${n}`;
    },
    timer() {
      const _this = this;
      var time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59;
          _this.minutes -= 1;
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0;
          window.clearInterval(time);
          this.$router.push({ path: '/cancelorder' });
        } else {
          _this.seconds -= 1;
        }
      }, 1000);
    },
    paycomplete(id) {
      if (id === 1) {
        this.$router.push({ path: `/payment?id=${id}` });
      } else {
        this.$router.push({ path: `/cancelorder?id=${id}` });
      }
    },
    back() {
      // this.$router.go(-1);//返回上一层
      this.$router.push({ path: '/academic?navaa=3' });
    },
  },
  mounted() {
    new Swiper('#swiper_fa3', {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
    });
    this.timer();
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
.fa1fb {
  display: block !important;
}
</style>
<style>
.paynoshow .el-carousel__indicators--horizontal {
  width: 100% !important;
  position: absolute !important;
  bottom: 0% !important;
  left: 0 !important;
  transform: translateX(0) !important;
  z-index: 99 !important;
  text-align: center;
}

.paynoshow .el-carousel__button {
  cursor: pointer;
  width: 7px;
  height: 7px;
  margin: 0 2.5px;
  float: left;
  position: relative;
  transition: all ease 0 0.35s;
  background-color: #1f232a;
  border-radius: 50%;
  opacity: 1;
  transition: all ease 0.35s;
}

.paynoshow .el-carousel__indicator.is-active button {
  background-color: #f6b415;
  width: 30px;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/paynocomplete.vue